module.exports = __webpack_public_path__ + "img/prontopiso.f6494739.png";